import React, { useRef } from 'react';
import { Box, Typography, Avatar, keyframes } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';

const testimonials = [
  {
    name: 'Janiece Emery',
    text: 'I was searching on Google for a laundry mat close to home and found 5-star Laundromat Winston-Salem. The laundromat looked exactly like the photos, clean and neat. I was greeted and given instructions on how to load/use the laundry card and tips for the machines. Washers range from 3.99 to 11.99 with free dry minutes depending on washer chosen. It was an overall good experience and I will return again for my laundry needs.',
    rating: 5,
    avatar: '/avatar1.png',
  },
  {
    name: 'Tara Floyd',
    text: 'This place is nice and clean. Very affordable. You can use your card or an app to load money on. No more trying to get dollars or charge. Customer service is excellent.',
    rating: 5,
    avatar: '/avatar2.png',
  },
  {
    name: 'Gina Harris',
    text: 'I had never considered the wash-dry-service before today…but I’m IN LOVE! This saved me so much time and energy. And it was so affordable. I will be doing this regularly. The laundromat itself is sparklingly clean—I’ll be bringing my comforters up to use the big machines very soon. The owners were so accommodating and answered all of my questions. Worth every penny. 52 lbs of laundry. DONE! Thank you! (Oh, they pickup and deliver too!)',
    rating: 5,
    avatar: '/avatar3.png',
  },
  {
    name: 'Carol Frazier',
    text: 'Very clean. Someone was on site to walk me through the usage of the equipment. Location is ideal for the surrounding community. Many machines in many different sizes. Payment is very convenient. I do recommend this business.',
    rating: 5,
    avatar: '/avatar4.png',
  },
  {
    name: 'Lakesha Brown',
    text: 'Great customer service from the attendant. Very clean modern, laundry mat, free drying with wash. Machines require laundry card or app that the attendant will help you with if you’re new to these payment methods. I recommend doing your laundry here!',
    rating: 5,
    avatar: '/avatar4.png',
  },
  {
    name: 'Mayli Montalvan',
    text: 'Went in on Monday place was really clean , all new washers and dryers. Owner was very friendly, helpful too! Would definitely recommend coming here !',
    rating: 5,
    avatar: '/avatar4.png',
  },
  {
    name: 'Bibi Higuera',
    text: 'Very clean laundromat, economical prices per wash. Washers and dryers are new. Owner was helpful and friendly, will return.',
    rating: 5,
    avatar: '/avatar4.png',
  },

];

const scrollAnimation = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(-50%); }
`;

const Testimonials: React.FC = () => {
  const scrollRef = useRef<HTMLDivElement>(null);

  return (
    <Box sx={{ padding: 4, backgroundColor: 'background.default', overflow: 'hidden' }}>
      <Typography variant="h4" align="center" sx={{ mb: 4 }}>
        What Our Customers Say
      </Typography>

      <Box
        sx={{
          display: 'flex',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          position: 'relative',
        }}
      >
        <Box
          ref={scrollRef}
          sx={{
            display: 'flex',
            gap: 3,
            animation: `${scrollAnimation} 20s linear infinite`,
            width: 'max-content',
          }}
        >
          {[...testimonials, ...testimonials].map((testimonial, index) => (
            <Box
              key={index}
              sx={{
                width: '300px',
                textAlign: 'center',
                padding: 2,
                borderRadius: 2,
                boxShadow: 2,
                backgroundColor: 'background.paper',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }}
            >
              <Avatar src={testimonial.avatar} alt={testimonial.name} sx={{ margin: '0 auto', mb: 2, backgroundColor: 'primary.main' }} />
              <Typography
                variant="body1"
                sx={{
                  fontStyle: 'italic',
                  mb: 1,
                  wordWrap: 'break-word',
                  whiteSpace: 'normal',
                }}
              >
                "{testimonial.text}"
              </Typography>
              <Typography variant="h6">{testimonial.name}</Typography>
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
                {Array.from({ length: testimonial.rating }).map((_, idx) => (
                  <StarIcon key={idx} sx={{ color: 'gold' }} />
                ))}
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default Testimonials;
